import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

@Component({
  selector: 'bdg-info-area',
  templateUrl: './info-area.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoAreaComponent {
  @Input()
  text: string

  @Input()
  title: string
}
